var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXWalletDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 130,
    viewBox: "0 0 592 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.54 126.669H210L193.64 74.9286H193.31L177.29 126.669H149.75L121.04 43.5586H150.58L164.93 96.1286H165.43L180.28 43.5586H207.82L223.17 96.1286H223.5L238.02 43.5586H266.39L237.52 126.669H237.54Z",
    fill: "#E3E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.45 54.9084C276.34 50.2384 282.05 46.7284 288.56 44.3984C295.07 42.0584 301.72 40.8984 308.5 40.8984C315.28 40.8984 321.43 41.7584 326.27 43.4884C331.11 45.2184 335.03 47.8884 338.04 51.4984C341.04 55.1184 343.24 59.6784 344.63 65.1784C346.02 70.6884 346.72 77.2284 346.72 84.7884V126.678H321.69V117.838H321.19C319.08 121.288 315.88 123.958 311.59 125.848C307.31 127.738 302.66 128.688 297.65 128.688C294.31 128.688 290.86 128.238 287.3 127.358C283.74 126.468 280.48 125.018 277.54 123.018C274.59 121.018 272.17 118.348 270.28 115.008C268.39 111.668 267.44 107.558 267.44 102.658C267.44 96.6484 269.08 91.8084 272.36 88.1384C275.64 84.4684 279.87 81.6284 285.04 79.6284C290.21 77.6284 295.97 76.2884 302.31 75.6184C308.65 74.9484 314.83 74.6184 320.83 74.6184V73.2884C320.83 69.1684 319.38 66.1384 316.49 64.1884C313.6 62.2384 310.04 61.2684 305.81 61.2684C301.91 61.2684 298.16 62.0984 294.54 63.7684C290.92 65.4384 287.84 67.4384 285.28 69.7784L271.43 54.9284L271.45 54.9084ZM321.68 90.4584H318.18C315.18 90.4584 312.14 90.5984 309.08 90.8784C306.02 91.1584 303.29 91.6884 300.9 92.4684C298.51 93.2484 296.53 94.3884 294.97 95.8884C293.41 97.3884 292.63 99.3684 292.63 101.818C292.63 103.378 292.99 104.708 293.71 105.828C294.43 106.938 295.35 107.828 296.46 108.498C297.57 109.168 298.85 109.638 300.3 109.918C301.74 110.198 303.14 110.338 304.47 110.338C310.03 110.338 314.29 108.808 317.24 105.748C320.19 102.688 321.66 98.5484 321.66 93.3184V90.4784L321.68 90.4584Z",
    fill: "#E3E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.01 126.67V0.5H388.88V126.67H361.01Z",
    fill: "#E3E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.34 126.67V0.5H432.21V126.67H404.34Z",
    fill: "#E3E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.18 86.1206V89.4606C528.18 90.5706 528.12 91.6306 528.01 92.6306H467.76C467.98 94.9706 468.68 97.0806 469.85 98.9706C471.02 100.861 472.52 102.501 474.36 103.891C476.2 105.281 478.25 106.371 480.54 107.141C482.82 107.921 485.18 108.311 487.63 108.311C491.97 108.311 495.64 107.501 498.65 105.891C501.65 104.281 504.1 102.191 505.99 99.6306L525.02 111.651C521.12 117.331 515.98 121.691 509.58 124.751C503.18 127.811 495.75 129.341 487.3 129.341C481.07 129.341 475.17 128.371 469.61 126.421C464.05 124.481 459.18 121.641 455.01 117.911C450.84 114.181 447.55 109.591 445.16 104.141C442.77 98.6906 441.57 92.4606 441.57 85.4506C441.57 78.4406 442.74 72.5206 445.07 67.0106C447.4 61.5006 450.58 56.8306 454.58 52.9906C458.59 49.1506 463.31 46.1806 468.77 44.0606C474.22 41.9506 480.12 40.8906 486.46 40.8906C492.8 40.8906 498.2 41.9206 503.32 43.9806C508.44 46.0406 512.83 49.0206 516.5 52.9106C520.17 56.8106 523.04 61.5306 525.1 67.1006C527.16 72.6606 528.19 79.0106 528.19 86.1306L528.18 86.1206ZM502.98 75.6106C502.98 71.2706 501.62 67.5406 498.89 64.4306C496.16 61.3206 492.07 59.7606 486.62 59.7606C483.95 59.7606 481.5 60.1806 479.28 61.0106C477.05 61.8406 475.11 62.9906 473.44 64.4306C471.77 65.8806 470.44 67.5706 469.43 69.5206C468.43 71.4706 467.87 73.5006 467.76 75.6106H502.97H502.98Z",
    fill: "#E3E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.57 63.9209V95.7509C571.57 99.6609 572.32 102.591 573.82 104.551C575.32 106.511 578.02 107.481 581.91 107.481C583.25 107.481 584.66 107.371 586.17 107.151C587.67 106.931 588.92 106.601 589.93 106.151L590.26 126.181C588.37 126.851 585.98 127.431 583.08 127.931C580.19 128.431 577.29 128.681 574.4 128.681C568.84 128.681 564.16 127.981 560.38 126.591C556.6 125.201 553.56 123.191 551.28 120.571C549 117.951 547.36 114.821 546.36 111.201C545.36 107.581 544.86 103.531 544.86 99.0709V63.9309H531.51V43.5709H544.69V21.7109H571.56V43.5709H591.09V63.9309H571.56L571.57 63.9209Z",
    fill: "#E3E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.94 52.3419L99.5 16.1719C101.56 14.1319 100.09 10.6719 97.16 10.6719H83.14L63.23 30.3019L62.94 52.3419Z",
    fill: "#B2B1BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.04 10.6719H28.34C25.4 10.6719 23.93 14.1519 26.01 16.1819L62.94 52.3419L63.23 30.3019L43.04 10.6719Z",
    fill: "#E3E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.23 74.832L26.74 111.002C24.68 113.042 26.15 116.502 29.08 116.502H43.04L63.23 96.872V74.832Z",
    fill: "#B2B1BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.13 116.502H97.89C100.83 116.502 102.3 113.022 100.22 110.992L63.23 74.832V96.912L83.14 116.512L83.13 116.502Z",
    fill: "#E3E3E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.74 41.42L51.76 41.4L26.01 16.18C23.93 14.15 25.4 10.67 28.34 10.67H43.04L36.98 4.73C36.98 4.73 33.02 0.5 30.05 0.5H9.12C-0.829996 0.5 -3.01 9.23 4.43 16.52L51.71 63.52L62.94 52.34L51.73 41.41L51.74 41.42Z",
    fill: "url(#paint0_linear_109_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.44 85.7584L74.42 85.7784L100.17 110.988C102.25 113.018 100.78 116.498 97.84 116.498H83.14L89.2 122.438C89.2 122.438 93.16 126.668 96.13 126.668H117.05C127.01 126.668 129.19 117.938 121.74 110.648L74.46 63.6484L63.23 74.8284L74.44 85.7584Z",
    fill: "url(#paint1_linear_109_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.74 16.52C129.19 9.23 127.01 0.5 117.05 0.5H96.13C93.16 0.5 89.2 4.73 89.2 4.73L83.14 10.67H97.16C100.09 10.67 101.56 14.13 99.5 16.17L74.21 41.2L62.94 52.35L51.71 63.53L51.77 63.59L51.74 63.62L4.43 110.65C-3.02 117.94 -0.84 126.67 9.12 126.67H30.04C33.01 126.67 36.97 122.44 36.97 122.44L43.03 116.5H29.01C26.08 116.5 24.61 113.04 26.67 111L51.96 85.97L63.23 74.82L74.46 63.64L74.4 63.58L74.43 63.55L121.73 16.52H121.74Z",
    fill: "url(#paint2_linear_109_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_2",
    x1: 127.09,
    y1: 121.66,
    x2: 14.6,
    y2: 4.05999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FBBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3382C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2B61AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C63E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2468"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_109_2",
    x1: 118.38,
    y1: 130.238,
    x2: 5.90002,
    y2: 12.6384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FBBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3382C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2B61AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#C63E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2468"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_109_2",
    x1: 117.15,
    y1: 6.35999,
    x2: 7.95999,
    y2: 121.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FA8747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ED5F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#862979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2468"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 591.1,
    height: 128.84,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWalletDark);
export default __webpack_public_path__ + "static/media/x-wallet-dark.471657510852da5e6a09bcfc33062088.svg";
export { ForwardRef as ReactComponent };